<template>
  <v-dialog v-model="dialog"  content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline">Privacy Policy</v-card-title>
      <v-card-text>
        <p>
          Eros tellus, justo pretium. Eros, accumsan sed consequat id convallis.
          Sociis fusce ornare auctor amet sagittis auctor curabitur felis id
          ipsum lectus tempor. Dictumst vulputate torquent urna suspendisse,
          suspendisse suspendisse luctus phasellus est habitasse? Ad ad fames
          inceptos eleifend nunc nostra nulla orci. Purus, dictumst rutrum
          ligula quam aenean vulputate nascetur varius. Vestibulum curabitur?
        </p>

        <p>
          Senectus consectetur maecenas lectus dapibus eget quisque integer.
          Iaculis taciti commodo amet tortor nam, sollicitudin duis platea
          dignissim quis malesuada. Accumsan ac tortor neque? Integer curabitur
          quam fringilla metus blandit pulvinar. Orci aliquam pellentesque
          fames. Nec augue nunc parturient leo magnis aenean. Amet pulvinar
          suscipit placerat, quam lorem euismod nisi cras. Ligula etiam
          curabitur, platea fusce sodales! Eros ultrices morbi nulla eleifend
          ultrices non? Blandit aliquam adipiscing cubilia, porttitor porttitor
          a amet senectus morbi. Varius dignissim gravida magnis rhoncus vel
          mauris at, litora hendrerit. Etiam potenti iaculis tortor semper
          tincidunt.
        </p>

        <p>
          Morbi rutrum ullamcorper, bibendum consequat. Mollis, est nostra
          nullam nisl molestie facilisi. Scelerisque amet platea amet enim duis
          duis dolor. Interdum blandit volutpat phasellus consequat, vestibulum
          nam luctus auctor nullam senectus vitae. Tincidunt scelerisque
          volutpat mi quis pretium adipiscing. Imperdiet mi eleifend nec. Orci
          mollis facilisi pharetra semper eleifend penatibus placerat risus
          volutpat. Dapibus primis pellentesque neque bibendum neque sociis
          quisque fames.
        </p>

        <p>
          Proin massa, et imperdiet diam sit sodales. Nullam cursus luctus,
          potenti in euismod nam sociis nisl. Rhoncus duis vehicula litora
          auctor sociis potenti. Interdum proin penatibus dolor justo pulvinar
          cum habitasse augue sem nisi eleifend adipiscing. Lacinia taciti
          auctor nulla hac. Donec adipiscing, sociis euismod sagittis vestibulum
          nascetur. Malesuada ipsum libero adipiscing ante elementum et, felis
          conubia duis venenatis rhoncus. Scelerisque varius.
        </p>
        <p>
          Sapien ac mattis lacus at viverra mollis justo magnis commodo libero
          dignissim. Sit placerat, cum suscipit fermentum varius pretium turpis
          ad tempus ante. Lacinia rhoncus rhoncus dolor bibendum elementum
          aliquam luctus! Tristique lacus ipsum fusce. Magnis faucibus penatibus
          erat, laoreet aliquam. Nisl fusce tempor duis purus et augue egestas
          cras ultrices. Rutrum proin tristique ultricies volutpat ligula
          imperdiet bibendum tortor. At velit sed fusce lacinia quis fermentum
          tristique. Ad amet parturient egestas sit ultricies iaculis eleifend.
          Sapien, enim mollis adipiscing euismod luctus bibendum erat ad. Aenean
          quis urna vitae proin eu magnis fusce sodales ullamcorper.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete" color="primary">Ok</v-btn>                
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UTIL from "src/helpers/utility";
export default {
  props: {
    item: Object,
    show: [Boolean, String],
  },
  components: {},
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      client: (state) => state.client,
      alert: (state) => state.alert,
    }),

    name() {
      return UTIL.gv(this.item, "companyName");
    },
  },
  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
  },
  methods: {
    ...mapActions("client", ["delete"]),
    closeDelete() {
      this.dialog = false;
      this.$store.dispatch("alert/clear");
      this.$emit("onClosed");
    },
    async deleteItemConfirm() {
      this.loading = true;
      await this.delete(this.item);
      if (!this.client.status.error) {
        this.closeDelete();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>